import { Box } from "@mui/material";
import React from "react";
import {
  Tooltip,
  LayersControl,
  MapContainer,
  ScaleControl,
  TileLayer,
  GeoJSON,
  Marker,
  useMapEvents,
  useMapEvent,
} from "react-leaflet";

import Basarang from "../location/Basarang.json";
import Bataguh from "../location/Bataguh.json";
import Dahadup from "../location/Dahadup.json";
import KapuasBarat from "../location/Kapuas-Barat.json";
import KapuasHilir from "../location/Kapuas-Hilir.json";
import KapuasHulu from "../location/Kapuas-Hulu.json";
import KapuasKuala from "../location/Kapuas-Kuala.json";
import KapuasMurung from "../location/Kapuas-Murung.json";
import KapuasTengah from "../location/Kapuas-Tengah.json";
import KapuasTimur from "../location/Kapuas-Timur.json";
import MandauTalawang from "../location/Mandau-Talawang.json";
import Mantangai from "../location/Mantangai.json";
import PasakTalawang from "../location/Pasak-Talawang.json";
import PulauPetak from "../location/Pulau-Petak.json";
import Selat from "../location/Selat.json";
import TambanCatur from "../location/Tamban-Catur.json";
import Timpah from "../location/Timpah.json";

export function MapsForm(params) {
  // console.log("Map Custom 2 : ", params.data);
  // console.log("Json Custom 2 : ", params.dataJson);

  const [marker, setMarker] = React.useState(params.marker);
  const [center, setCenter] = React.useState([-1.922, 114.373]);

  function ClickMark() {
    const map = useMapEvent("click", (e) => {
      setMarker(e.latlng);
      params.latitude(e.latlng.lat);
      params.longitude(e.latlng.lng);
    });
    return null;
  }

  function GoToMarker(marker) {
    const map = useMapEvent("click", () => {
      map.setView(marker, map.getZoom());
    });
    return null;
  }

  return (
    <Box
      width={"100%"}
      height={"100%"}
      textAlign={"left"}
      bgcolor={"#ffffff"}
      padding={2}
      border={"1px solid #D3D3D3"}
      borderRadius={4}
    >
      <MapContainer
        center={center}
        zoom={7}
        minZoom={7}
        maxZoom={15}
        doubleClickZoom
        scrollWheelZoom={true}
      >
        <ClickMark />

        <ScaleControl metric={true} imperial={false} position="bottomright" />

        <LayersControl
          position="topright"
          // collapsed={false}
        >
          <LayersControl.BaseLayer
            name="Open Street Maps"
            key={"layer-0"}
            children={
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                key={"open_street_maps"}
              />
            }
          />
          <LayersControl.BaseLayer
            name="Google Maps (Satelitte)"
            checked="true"
            key={1}
            children={
              <TileLayer
                attribution='&copy; <a href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">GoogleMaps</a>'
                url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
                key={"google_earth"}
              />
            }
          />
        </LayersControl>

        <LayersControl position="topright" >
          {kapuasMaps.map((item, index) => (
            <LayersControl.BaseLayer name={item.title}>
              <GeoJSON
                key={("geoJson-", index)}
                data={item.data}
                style={{ weight: 1}}
              >
              </GeoJSON>
            </LayersControl.BaseLayer>
          ))}
        </LayersControl>

        {marker && <Marker position={marker} />}
      </MapContainer>
    </Box>
  );
}

const kapuasMaps = [
  {
    title: "Basarang",
    data: Basarang,
    center: [-2.960662909944844, 114.30593696968697],
    zoom: 11,
    color:"#FF0000"
  },
  {
    title: "Bataguh",
    data: Bataguh,
    center: [-3.1838413458253996, 114.27481185689663],
    zoom: 10,
    color:"#00FF00"
  },
  {
    title: "Dahadup",
    data: Dahadup,
    center: [-2.6286924437262087, 114.6281539106547],
    zoom: 10,
    color:"#0000FF"
  },
  {
    title: "Kapuas Barat",
    data: KapuasBarat,
    center: [-2.799383075019975, 114.38917206198403],
    zoom: 10,
    color:"#FFFF00"
  },
  {
    title: "Kapuas Hilir",
    data: KapuasHilir,
    center: [-2.9908446737791508, 114.45728719315639],
    zoom: 10,
    color:"#00FFFF"
  },
  {
    title: "Kapuas Hulu",
    data: KapuasHulu,
    center: [-0.7440771486200219, 113.77190680983551],
    zoom: 9,
    color:"#FF00FF"
  },
  {
    title: "Kapuas Kuala",
    data: KapuasKuala,
    center: [-3.337111635796532, 114.30279312308323],
    zoom: 10,
    color:"#FFA500"
  },
  {
    title: "Kapuas Murung",
    data: KapuasMurung,
    center: [-2.7508284730909622, 114.64556789592712],
    zoom: 10,
    color:"#800080 "
  },
  {
    title: "Kapuas Tengah",
    data: KapuasTengah,
    center: [-1.2019933801033176, 114.38017155535312],
    zoom: 10,
    color:"#FFC0CB"
  },
  {
    title: "Kapuas Timur",
    data: KapuasTimur,
    center: [-3.0683075423080624, 114.46009246298041],
    zoom: 8,
    color:"#A52A2A"
  },
  {
    title: "Mandau Talawang",
    data: MandauTalawang,
    center: [-0.6407911173025838, 113.97275881375054],
    zoom: 10,
    color:"#808080"
  },
  {
    title: "Mantangai",
    data: Mantangai,
    center: [-1.9955445831515561, 114.2984834881367],
    zoom: 10,
    color:"#991414ff"
  },
  {
    title: "Pasak Talawang",
    data: PasakTalawang,
    center: [-1.0333248378244377, 114.19078626115288],
    zoom: 10,
    color:"#000000"
  },
  {
    title: "Pulau Petak",
    data: PulauPetak,
    center: [-2.9025577320623057, 114.49425999424551],
    zoom: 10,
    color:"#FFFFFF"
  },
  {
    title: "Selat",
    data: Selat,
    center: [-2.9915998938563604, 114.39073715465673],
    zoom: 10,
    color:"#008080"
  },
  {
    title: "Tamban Catur",
    data: TambanCatur,
    center: [-3.2155543478857282, 114.38446817033315],
    zoom: 10,
    color:"#800000"
  },
  {
    title: "Timpah",
    data: Timpah,
    center: [-1.606636668699167, 114.51081176482086],
    zoom: 9,
    color:"#000080"
  },
];